"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
require("@hotmart/cosmos/dist/sidebar/sidebar-body");
const SidebarBody = ({ className, children }) => ((0, jsx_runtime_1.jsx)("hot-sidebar-body", { class: className, children: children }));
exports.default = SidebarBody;
